var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"survey-prompt",on:{"click":_vm.redirectTo}},[_c('div',[_vm._v(" Complete your Setup for Survey "),_c('strong',[_vm._v(_vm._s(_vm.draftSurvey.name))]),_vm._v(" now! ")]),_c('img',{attrs:{"src":require("@/assets/img/Icons/right-arrow-white.svg"),"alt":"right arrow"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }